import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ExtendedMap } from '@jeppesen-foreflight/jmkw-types';
import { Observable } from 'rxjs';
import { createTimeMap, TwcTime } from '../twc-time';
import { filterAndSortTimeMap, TwcTimeUnit } from '../twc.utils';
import { TwcParams, TwcResponseData } from './twc.data.types';
import { TWC_CONFIG_TOKEN } from '../plugins/twc-config.token';

@Injectable()
export abstract class BaseTwcService<T extends TwcResponseData> {
  protected httpClient = inject(HttpClient);
  protected env = inject(TWC_CONFIG_TOKEN);
  protected twcApiKey = this.env.apiKey;

  abstract getTwcData$(params: TwcParams): Observable<T>;

  protected createTimeMap(
    times: string[],
    isForecast: boolean,
    timeUnit: TwcTimeUnit = 'milliseconds'
  ): ExtendedMap<TwcTime> {
    const unfilteredMap = createTimeMap(times);

    if (isForecast) {
      return filterAndSortTimeMap(unfilteredMap, timeUnit);
    }

    const latestTime = times.sort((a, b) => b.localeCompare(a))[0];
    return latestTime
      ? new ExtendedMap([[latestTime, new TwcTime(latestTime)]])
      : new ExtendedMap();
  }

  protected getHttpParams(params: Record<string, string>): HttpParams {
    return new HttpParams({ fromObject: params });
  }
}
